export default __webpack_public_path__ + "static/media/bamboo-inline.c14088e2.svg";